module["exports"] = [
  "/6767-####-####-###L/",
  "/6767-####-####-####-#L/",
  "/6767-####-####-####-##L/"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/credit_card/solo.js
// module id = 1286
// module chunks = 1